var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mention-coingecko"},[_vm._v(" Powered by "),_c('a',{staticClass:"mention-coingecko__url",attrs:{"href":"https://www.coingecko.com/es/api","target":"_blank"}},[_vm._v(" CoinGecko API ")])])
}]

export { render, staticRenderFns }